import React from "react";
import { useState } from "react";
import checkIcon from "assets/icons/check.svg";
import closeIcon from "assets/icons/close.svg";
import ContractTermsMain from "../../components/SystemLevelSettings/ContractTerms/ContractTermsMain";
import MainLayout from 'layouts/mainLayout'
const dataObjectColumns = [
  {
    field: "name",
    headerName: "DATA OBJECT",
    width: 340,
    sortable: false,
    renderCell: ({ row }) => row.label
  },
  {
    field: "checked",
    headerName: "CONTRACTED",
    width: 140,
    sortable: false,
    align: "center",
    headerAlign: "center",
    renderCell: ({ row }) => {
      return row.checked === true ? (
        <img height="20px" src={checkIcon} alt="historyIcon" />
      ) : (
        <img height="20px" src={closeIcon} alt="historyIcon" />
      );
    }
  }
];

const monitoringColumns = [
  {
    field: "name",
    headerName: "MONITORING SERVICES",
    width: 340,
    sortable: false,
    renderCell: ({ row }) => row.label
  },
  {
    field: "checked",
    headerName: "CONTRACTED",
    align: "center",
    headerAlign: "center",
    width: 140,
    sortable: false,
    renderCell: ({ row }) => {
      return row.checked === true ? (
        <img height="20px" src={checkIcon} alt="historyIcon" />
      ) : (
        <img height="20px" src={closeIcon} alt="historyIcon" />
      );
    }
  }
];

const matchingColumns = [
  {
    field: "name",
    headerName: "MATCHING SERVICES",
    width: 340,
    sortable: false,
    renderCell: ({ row }) => row.label
  },
  {
    field: "checked",
    headerName: "CONTRACTED",
    align: "center",
    headerAlign: "center",
    width: 140,
    sortable: false,
    renderCell: ({ row }) => {
      return row.checked === true ? (
        <img height="20px" src={checkIcon} alt="historyIcon" />
      ) : (
        <img height="20px" src={closeIcon} alt="historyIcon" />
      );
    }
  }
];

export default function ContractTermsPage() {

  const [contractTermValues, setContractTermValues] = useState({
    partnerId: null,
    advancedMatchingEnabled: false,
    standardMatchingEnabled: true,
    bizFirmograhicEnabled: true,
    bizHealthEnabled: false,
    bizComplianceEnabled: false,
    bizHeirarchyEnabled: false,
    bizDiversityEnabled: true,
    officerNameMatchingEnabled: false,
    businessMonitoringEnabled: false,
    complianceMonitoringEnabled: false,
    businessLookupFreeRetrievalsLimit: null,
    bizDecisionEnabled: false,
    bizSearchEnabled: false
  })

  function handleCheckboxChange(rowData) {
    return function (_, checked) {
      const changedValue = { ...contractTermValues, [rowData.checkboxKey]: checked };
      setContractTermValues(changedValue)
    };
  }

  const partners = [
    {
      "id": 1,
      "name": "ACME -Test",
      "description": "EPSG Markaaz Patner",
      "logoURI": "https://markaazwebobjects-dev.markaaz.tech/svg/epsg.svg",
      "stagingEpId": 1001
    },
    {
      "id": 828,
      "name": "Testing EP",
      "description": "",
      "logoURI": "",
      "stagingEpId": 965
    }
  ]

  return (
    <MainLayout>
      <ContractTermsMain
        dataObjectColumns={dataObjectColumns}
        monitoringColumns={monitoringColumns}
        matchingColumns={matchingColumns}
        showNotification={false}
        submitInProgress={false}
        isSuperUser={true}
        userRole={"STAFF_SUPER_USER"}
        partners={partners}
        values={contractTermValues}
        onAlertClose={() => { }}
        onSubmit={() => { }}
        onCheckboxChange={handleCheckboxChange}
        onTermsButtonClick={() => { }}
      />
    </MainLayout>);
}
